export default __webpack_public_path__ + "static/balance_equations-2bc5a85b84de8ac7e7e7f4420eeed487.mp4";